import { render, staticRenderFns } from "./ShortVideoMy.vue?vue&type=template&id=fc397110&scoped=true"
import script from "./ShortVideoMy.vue?vue&type=script&lang=js"
export * from "./ShortVideoMy.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoMy.vue?vue&type=style&index=0&id=fc397110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc397110",
  null
  
)

export default component.exports